import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer group">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-stack-line text-lg"></i>
              </div>
              <span className="text-background-50 font-heading text-base font-semibold">
                USFans<span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              Kompletny przewodnik i centrum wiedzy o USFansSpreadsheet. 
              Recenzje, porównania, poradniki i najlepsze praktyki dla każdego użytkownika.
            </p>
          </div>

          <div>
            <h3 className="font-heading text-background-50 font-semibold mb-4">Nawigacja</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Strona główna
                </Link>
              </li>
              <li>
                <Link to="/artykul/kompletny-przewodnik-usfansspreadsheet-2026" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Kompletny przewodnik
                </Link>
              </li>
              <li>
                <Link to="/artykul/jak-korzystac-usfansspreadsheet" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Jak korzystać
                </Link>
              </li>
              <li>
                <Link to="/artykul/czy-usfansspreadsheet-jest-bezpieczny" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Bezpieczeństwo
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-background-50 font-semibold mb-4">Zasoby</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artykul/usfansspreadsheet-vs-excel" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  USFansSpreadsheet vs Excel
                </Link>
              </li>
              <li>
                <Link to="/artykul/alternatywy-usfansspreadsheet" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Alternatywy
                </Link>
              </li>
              <li>
                <Link to="/artykul/opinie-usfansspreadsheet" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Opinie użytkowników
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Kaspreadsheet.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-background-50 font-semibold mb-4">Sklep</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Hoodies/Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer">
                  Zobacz wszystkie →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} USFansSpreadsheet.study. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              Polityka prywatności
            </Link>
            <Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              Kontakt
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}